
import { Vue, Component } from "vue-property-decorator";
import DateTime from "@/components/overlay/components/centerMenu/DateTime.vue";
import PlayerControls from "@/components/overlay/components/centerMenu/PlayerControls.vue";
import { Getter } from "vuex-class";
import { OverlayGetter, OverlaySection } from "@/components/overlay/types";
import { Namespace } from "@/store/types";
import ChannelInfo from "@/components/overlay/components/centerMenu/PlaybackItemInfo.vue";

@Component({
  components: { ChannelInfo, PlayerControls, DateTime }
})
export default class CenterMenuBase extends Vue {
  @Getter(OverlayGetter.GetOverlayOpen, {
    namespace: Namespace.Overlay
  })
  getOverlayOpen!: OverlaySection;
}
